import { useEffect, useRef, useState } from "react";
import { Check, ImagePlus, Trash2, Upload, Wand2 } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg } from "@/lib/api";
import { Modal } from "./Dialogs";

export const ImageLibrary = ({ onPick, onClose, replacing }) => {
  const [files, setFiles] = useState([]);
  const [busy, setBusy] = useState("");
  const input = useRef();
  const load = () => api.get("/files").then((r) => setFiles(r.data));
  useEffect(() => { load(); }, []);
  const upload = async (list) => {
    for (const f of list) {
      const fd = new FormData(); fd.append("file", f);
      setBusy("upload");
      try { await api.post("/files/upload", fd); } catch (e) { toast.error(errMsg(e)); }
    }
    setBusy(""); load();
  };
  const removeBg = async (f) => {
    setBusy(f.id);
    try { await api.post(`/files/${f.id}/remove-bg`); toast.success("Fundo removido! Nova imagem adicionada à biblioteca."); load(); } catch (e) { toast.error(errMsg(e)); } finally { setBusy(""); }
  };
  const del = async (f) => { await api.delete(`/files/${f.id}`); load(); };
  return (
    <Modal title={replacing ? "Trocar imagem" : "Biblioteca de imagens"} onClose={onClose} wide testid="image-library">
      <div onDragOver={(e) => e.preventDefault()} onDrop={(e) => { e.preventDefault(); upload([...e.dataTransfer.files]); }} className="rounded-2xl border-2 border-dashed border-slate-300 p-6 text-center text-sm text-slate-500 hover:border-[var(--blue)] transition-colors">
        <Upload size={20} className="mx-auto text-slate-400" />
        <p className="mt-2">Arraste imagens aqui ou <button data-testid="library-upload-button" onClick={() => input.current.click()} className="text-[var(--blue)] font-medium">escolha do computador</button> · JPG, PNG, WEBP, GIF, SVG até 10 MB</p>
        <input ref={input} data-testid="library-file-input" type="file" accept="image/*" multiple className="hidden" onChange={(e) => upload([...e.target.files])} />
        {busy === "upload" && <p className="mt-2 text-xs text-[var(--blue)]">Enviando…</p>}
      </div>
      <div className="mt-5 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-3 max-h-[50vh] overflow-y-auto pr-1">
        {files.length === 0 && <p data-testid="library-empty" className="col-span-full text-center text-sm text-slate-400 py-8">Nenhuma imagem ainda.</p>}
        {files.map((f) => (
          <div key={f.id} data-testid={`library-file-${f.id}`} className="group relative rounded-xl border border-slate-200 overflow-hidden bg-[conic-gradient(#f1f5f9_25%,#fff_0_50%,#f1f5f9_0_75%,#fff_0)] bg-[length:16px_16px]">
            <img src={f.url} alt={f.original_filename} className="aspect-square w-full object-contain" loading="lazy" />
            <div className="absolute inset-x-0 bottom-0 bg-white/95 p-2 text-[10px] truncate">{f.origin === "remove-bg" && <span className="text-[var(--orange)] font-semibold">sem fundo · </span>}{f.original_filename}</div>
            <div className="absolute inset-0 bg-[var(--ink)]/70 opacity-0 group-hover:opacity-100 transition-opacity flex flex-col items-center justify-center gap-1.5 p-2">
              <button data-testid={`library-pick-${f.id}`} onClick={() => onPick(f)} className="btn !py-1.5 !px-3 text-xs bg-white text-[var(--ink)] w-full justify-center"><Check size={12} /> {replacing ? "Usar" : "Inserir"}</button>
              {f.content_type !== "image/svg+xml" && <button data-testid={`library-removebg-${f.id}`} disabled={!!busy} onClick={() => removeBg(f)} className="btn !py-1.5 !px-3 text-xs bg-[var(--orange)] text-white w-full justify-center disabled:opacity-60"><Wand2 size={12} /> {busy === f.id ? "Removendo…" : "Remover fundo"}</button>}
              <button onClick={() => del(f)} className="text-white/70 hover:text-red-300 text-xs flex items-center gap-1 mt-1"><Trash2 size={11} /> excluir</button>
            </div>
          </div>
        ))}
      </div>
      <p className="mt-3 text-[11px] text-slate-400 flex items-center gap-1"><ImagePlus size={11} /> Remoção de fundo usa IA (Gemini) e gera um PNG transparente novo, mantendo o original.</p>
    </Modal>
  );
};
